import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import ProceduresRepository from '../../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../../data/repositories/ProceduresDataRepository';
import config from '../../../../../core/config/config';

const spreadPages = (arrayResponse: any) => {
  const arrayResult = [];

  for (let i = 0, j = arrayResponse?.length; i < j; i += 8) {
    const result = arrayResponse?.slice(i, 8 + i);
    arrayResult.push({ id: (i + 8) / 8, page: (i + 8) / 8, items: result });
  }

  return arrayResult;
};

export default function* saga(action: any): any {
  try {
    const { request } = action;
    yield put({ type: Types.GET_PROCEDURES_CREATED_REQUEST });
    const procedureRepository: ProceduresRepository =
      new ProceduresDataRepository();
    const procedureResponse = yield call(
      procedureRepository.getProceduresCreated,
      request
    );

    if (!procedureResponse) {
      yield put({
        type: Types.GET_PROCEDURES_CREATED_FAILURE,
        error: true
      });
      return;
    }

    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1500);
    const pages = spreadPages(procedureResponse);
    const selectedPage = pages[0];

    yield put({
      type: Types.GET_PROCEDURES_CREATED_SUCCESS,
      data: pages,
      onlyPage: selectedPage,
      pagesArray: pages.map((row: any) => row.page)
    });
  } catch (error) {
    yield put({
      type: Types.GET_PROCEDURES_CREATED_FAILURE,
      error: 'Ocurrió un error al momento de leer los trámites.'
    });
  }
}
